import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseDeleteCouponMutationProps = {
	id: number | null
	onSettled: () => void
}

export const useDeleteCouponMutation = ({ id, onSettled }: UseDeleteCouponMutationProps) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: couponDeleteMutation } = useMutation({
		mutationFn: () => {
			// TODO: change to apiRoutes
			return axiosPrivate.delete(`/coupons/${id}/`)
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Coupon deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.coupons.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		couponDeleteMutation
	}
}
